'use client';
import React from 'react';

interface ToggleProps {
  checked: boolean;
  onChange: (v: boolean) => void;
  label?: string;
  size?: 'sm' | 'md';
  disabled?: boolean;
}

export default function Toggle({ checked, onChange, label, size = 'md', disabled = false }: ToggleProps) {
  const trackW = size === 'sm' ? 'w-8' : 'w-11';
  const trackH = size === 'sm' ? 'h-4' : 'h-6';
  const thumbW = size === 'sm' ? 'w-3 h-3' : 'w-4 h-4';
  const translate = size === 'sm' ? (checked ? 'translate-x-4' : 'translate-x-0.5') : (checked ? 'translate-x-5' : 'translate-x-1');

  return (
    <label className={`flex items-center gap-3 cursor-pointer ${disabled ? 'opacity-50 pointer-events-none' : ''}`}>
      <button
        role="switch"
        aria-checked={checked}
        onClick={() => onChange(!checked)}
        className={`relative inline-flex ${trackW} ${trackH} rounded-full transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 focus:ring-offset-background
          ${checked ? 'bg-primary' : 'bg-muted'}`}
        disabled={disabled}
      >
        <span
          className={`${thumbW} rounded-full bg-white shadow-sm transition-transform duration-200 absolute top-1/2 -translate-y-1/2 ${translate}`}
        />
      </button>
      {label && <span className="text-sm text-foreground font-medium">{label}</span>}
    </label>
  );
}